import { trackEvent } from "../shared/mixpanel";
import apiClient from "./apiClient";

const OrganizationService = {
  getBranding: async () => {
    try {
      const response = await apiClient.get("organizations/branding");
      return response.data;
    } catch (error) {
      console.error("Error fetching organization branding:", error);
      throw error;
    }
  },
  updateBranding: async (payload) => {
    try {
      const response = await apiClient.put("organizations/branding", payload);
      trackEvent("Branding Updated", {});
      return response.data;
    } catch (error) {
      console.error("Error updating organization branding:", error);
      throw error;
    }
  },
};

export default OrganizationService;
